import { Component, input } from '@angular/core';

@Component({
  selector: 'syn-assessment-label',
  templateUrl: './assessment-label.component.html',
  styleUrls: ['./assessment-label.component.scss'],
})
export class AssessmentLabelComponent {
  readonly name = input<string>(undefined);
}
